// Etiquetas del cockpit por giro. El módulo clinical-cockpit se reutiliza
// para clínica (MedOS · healthcare-clinic) y para eventos/servicios
// (events-services · José). Mismo backend y componentes, distinta
// terminología. 🔒 FUENTE ÚNICA — no duplicar estos strings en los
// componentes; consúmelos desde aquí vía cockpitLabels(archetype).

export interface CockpitLabels {
  events: boolean;
  // Home
  loading: string;
  noAgenda: string;
  clientsAlerts: string;
  noAlerts: string;
  pendingRecords: string;
  pendingRecordsHint: string;
  newClients: string;
  metricMain: string;
  metricUnique: string;
  metricUniqueShort: string;
  assistantTitle: string;
  assistantHint: string;
  // Lista de clientes / pacientes
  entity: string;
  searchPlaceholder: string;
  emptyList: string;
  openRecord: string;
  // Drawer / ficha
  recordLabel: string;
  recordLoading: string;
}

export function cockpitLabels(archetype: string | null): CockpitLabels {
  const events = archetype === 'events-services';
  return {
    events,
    loading: events ? 'Cargando panel…' : 'Cargando consultorio…',
    noAgenda: events ? 'Sin eventos programados hoy.' : 'Sin citas programadas hoy.',
    clientsAlerts: events ? 'Clientes con seguimiento' : 'Pacientes con alertas',
    noAlerts: events ? 'Ningún cliente con banderas activas.' : 'Ningún paciente con banderas activas.',
    pendingRecords: events ? 'Cotizaciones por enviar' : 'Expedientes por firmar',
    pendingRecordsHint: events ? 'cotizaciones listas para mandar' : 'consultas de hoy listas para firmar',
    newClients: events ? 'Nuevos clientes esta semana' : 'Nuevos pacientes esta semana',
    metricMain: events ? 'Eventos' : 'Consultas',
    metricUnique: events ? 'Clientes únicos' : 'Pacientes únicos',
    metricUniqueShort: events ? 'Clientes (semana)' : 'Pacientes (semana)',
    assistantTitle: events ? 'Asistente — listo' : 'Asistente clínico — listo',
    assistantHint: events
      ? 'Pregúntale por cualquier cliente o cotización: "Cuéntame de la boda de Samuel", "¿Qué eventos tengo esta semana?", "Prepárame la cotización de XV". Abre el botón flotante de chat en la esquina.'
      : 'Pregúntale por cualquier paciente: "Cuéntame de María Fernanda", "¿Quién tiene cirugía mañana?", "Prepárame el brief de Roberto". Abre el botón flotante de chat en la esquina.',
    entity: events ? 'Cliente' : 'Paciente',
    searchPlaceholder: events
      ? 'Buscar cliente por nombre o teléfono…'
      : 'Buscar paciente por nombre o número de expediente…',
    emptyList: events ? 'Sin clientes activos.' : 'Sin pacientes activos.',
    openRecord: events ? 'Abrir ficha' : 'Abrir expediente',
    recordLabel: events ? 'Ficha' : 'Expediente',
    recordLoading: events ? 'Cargando ficha…' : 'Cargando expediente…',
  };
}
